"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../");
var AppConfig_1 = require("../../AppConfig");
;
var GridDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n    border: 1px solid transparent;\n\n    &:hover {\n        border: 1px solid ", ";\n    }\n"], ["\n    cursor: pointer;\n    border: 1px solid transparent;\n\n    &:hover {\n        border: 1px solid ", ";\n    }\n"])), AppConfig_1.UIConfig.ThemeColorBrightPurpleOpaque);
var PctIndicatorBase = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    background: ", ";\n"], ["\n    position: relative;\n    width: 100%;\n    background: ", ";\n"])), AppConfig_1.UIConfig.ThemeColorYellow);
var PctIndicator = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    width: ", ";\n    height: 1px;\n    background: ", ";\n"], ["\n    position: relative;\n    width: ", ";\n    height: 1px;\n    background: ", ";\n"])), function (props) { return props.widthPercent + '%'; }, AppConfig_1.UIConfig.ThemeColorBrightPurpleOpaque);
var GridList = function (_a) {
    var data = _a.data, onClick = _a.onClick, onHoverHandler = _a.onHoverHandler;
    var getElements = function () {
        if (!data || !data.length) {
            return null;
        }
        var blocks = data
            .filter(function (d) { return d; })
            .map(function (d) {
            var classBreak = d.classBreak, attributes = d.attributes;
            var PercentContained = attributes.PercentContained, UniqueFireIdentifier = attributes.UniqueFireIdentifier;
            return (React.createElement(GridDiv, { key: "grid-block-" + UniqueFireIdentifier, className: 'block trailer-half', onClick: onClick.bind(_this, d), onMouseEnter: onHoverHandler.bind(_this, d), onMouseLeave: onHoverHandler.bind(_this, null) },
                React.createElement(__1.FireflyIcon, { size: classBreak }),
                React.createElement(PctIndicatorBase, null,
                    React.createElement(PctIndicator, { widthPercent: PercentContained }))));
        });
        return (React.createElement("div", { className: 'block-group block-group-6-up' }, blocks));
    };
    return (React.createElement(React.Fragment, null, getElements()));
};
exports.default = GridList;
var templateObject_1, templateObject_2, templateObject_3;
